<template>
  <div>
    <el-button
      v-if="actions && actions.terminate"
      v-on:click.stop="$emit('terminate', actions.terminate)"
      class="button"
      size="small"
      type="success"
      plain
    >
      <i class="fas fa-check"></i> {{ $t("terminate") }}
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    actions: Object,
  },
};
</script>

<style lang="scss" scoped>
.button {
  margin-right: 1rem;
}
</style>

<i18n>
{
  "en": {
    "terminate": "Close"
  },
  "fr": {
    "terminate": "Terminer"
  },
  "de": {
    "terminate": "Beenden"
  }
}
</i18n>
